<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="imgWrap schedule">
            <img :src="'https://api.thanq.kr' +  getSchedule.image">
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '진료 시간표',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  computed: {
    ...mapGetters([
      'getSchedule'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([
      'DOCTOR_SCHEDULE'
    ]),
    async fetchData () {
      try {
        this.DOCTOR_SCHEDULE()
      } catch (error) {
        console.log('error :', error);
        console.log('의료진 스케쥴 조회 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.fetchData()
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
